exports.tokens = {
  "LabelRegularXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelMediumXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelSemiboldXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelRegularS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelMediumS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelSemiboldS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelRegularM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelMediumM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelSemiboldM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelRegularXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelRegularL": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "18",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "LabelMediumL": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "18",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "LabelMediumXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelSemiboldXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "100%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyRegularXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodySemiboldXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "135%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyRegularS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodySemiboldS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyRegularM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodySemiboldM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyRegularXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodySemiboldXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumL": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "18",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "BodyRegularL": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "fontSize": "18",
    "lineHeight": "135%",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "HeadingMedium6": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "60",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular6": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "60",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular5": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "48",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium5": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "48",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium4": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "36",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular4": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "36",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium3": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "30",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular3": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "30",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium2": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "24",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular2": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "24",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium1": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular1": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LinkRegularXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "LinkRegularS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "LinkRegularM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "LinkMediumS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "LinkMediumM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "SizeComponentXs": "24px",
  "SizeComponentS": "32px",
  "SizeComponentM": "40px",
  "SizeComponentL": "48px",
  "SizeComponentXl": "56px",
  "SizeComponentXxl": "64px",
  "SizeIconS16": "16px",
  "SizeIconS18": "18px",
  "SizeIconS20": "20px",
  "SizeIconS22": "22px",
  "SizeIconS24": "24px",
  "SizeIconS26": "26px",
  "SizeIconS28": "28px",
  "SizeIconS30": "30px",
  "SizeIconS32": "32px",
  "SizeIconS34": "34px",
  "SizeIconL36": "36px",
  "SizeIconL38": "38px",
  "SizeIconL40": "40px",
  "SizeIconL42": "42px",
  "SizeIconL44": "44px",
  "SizeIconL46": "46px",
  "SizeIconL48": "48px",
  "SizeIconL50": "50px",
  "SizeIconL52": "52px",
  "SizeIconL54": "54px",
  "SizeIconL56": "56px",
  "SizeIconL58": "58px",
  "SizeIconL60": "60px",
  "SizeIconL62": "62px",
  "SizeIconL64": "64px",
  "SizeIconL66": "66px",
  "SizeIconL68": "68px",
  "SpaceComponentNone": "0",
  "SpaceComponentXs": "4",
  "SpaceComponentS": "8",
  "SpaceComponentM": "16",
  "SpaceComponentL": "24",
  "SpaceComponentXl": "32",
  "SpaceLayoutXs": "8",
  "SpaceLayoutS": "16",
  "SpaceLayoutM": "24",
  "SpaceLayoutL": "32",
  "SpaceLayoutXl": "40",
  "SpaceLayoutXxl": "48",
  "BorderWidthDefault": "1",
  "BorderWidthFocused": "1.5",
  "BorderWidthHover": "2",
  "BorderWidthSubtle": "0.5",
  "ShadowTop": {
    "x": "0",
    "y": "3",
    "blur": "8",
    "spread": "0",
    "color": "#0000001a",
    "type": "dropShadow"
  },
  "ShadowBottom": {
    "x": "0",
    "y": "-3",
    "blur": "8",
    "spread": "0",
    "color": "#0000001a",
    "type": "dropShadow"
  },
  "MotionDurationFunctional": "400 ms",
  "MotionDurationProductive": "800 ms",
  "MotionDurationExpressive": "1000 ms",
  "MotionDurationFastest": "50 ms",
  "MotionDurationExtraFast": "100 ms",
  "MotionDurationFast": "150 ms",
  "MotionDurationMedium": "200 ms",
  "MotionDurationMediumSlow": "250 ms",
  "MotionDurationSlow": "300 ms",
  "MotionDurationExtraSlow": "500 ms",
  "MotionEasingCurveLinear": "0, 0, 1, 1",
  "MotionEasingCurveFunctional": "0.66, 0, 0.34, 1",
  "MotionEasingCurveProductive": "0.84, 0, 0.16, 1",
  "MotionEasingCurveExpressive": "0.68, -0.55, 0.27, 1.55",
  "MotionEasingCurveEaseIn": "0.42, 0.00, 1.00, 1.00",
  "MotionEasingCurveEaseOut": "0.00, 0.00, 0.58, 1.00",
  "MotionEasingCurveBack": "0.68, -0.55, 0.27, 1.55",
  "PropertiesAria25": "#E6EAEE",
  "PropertiesAria500": "#022958",
  "PropertiesAria900": "#011935",
  "PropertiesBellagio25": "#E5EFF1",
  "PropertiesBellagio500": "#005B70",
  "PropertiesBellagio900": "#003743",
  "PropertiesTheCosmopolitan25": "#EFEAF1",
  "PropertiesTheCosmopolitan500": "#612C73",
  "PropertiesTheCosmopolitan900": "#3A1A45",
  "PropertiesDelano25": "#F2F2F3",
  "PropertiesDelano500": "#7E8083",
  "PropertiesDelano900": "#4C4D4F",
  "PropertiesExcalibur25": "#EEEAEA",
  "PropertiesExcalibur500": "#572D2D",
  "PropertiesExcalibur900": "#341B1B",
  "PropertiesLuxor25": "#E5E5E5",
  "PropertiesLuxor500": "#57555A",
  "PropertiesLuxor900": "#000000",
  "PropertiesMandalayBay25": "#EEF0F3",
  "PropertiesMandalayBay500": "#556B8A",
  "PropertiesMandalayBay900": "#334053",
  "PropertiesMgmGrand25": "#F8F6F1",
  "PropertiesMgmGrand500": "#BDA770",
  "PropertiesMgmGrand900": "#716443",
  "PropertiesNewYorkNewYork25": "#E6EDF2",
  "PropertiesNewYorkNewYork500": "#024F80",
  "PropertiesNewYorkNewYork900": "#012F4D",
  "PropertiesNomad25": "#EFE9EC",
  "PropertiesNomad500": "#612141",
  "PropertiesNomad900": "#3A1427",
  "PropertiesParkMgm25": "#EFF2ED",
  "PropertiesParkMgm500": "#5B794E",
  "PropertiesParkMgm900": "#37492F",
  "PropertiesTheSignature25": "#E9E9E9",
  "PropertiesTheSignature500": "#444141",
  "PropertiesTheSignature900": "#231F20",
  "PropertiesVdara25": "#F1F0EF",
  "PropertiesVdara500": "#71655F",
  "PropertiesVdara900": "#443D39",
  "PropertiesBeauRivage25": "#E9EFF7",
  "PropertiesBeauRivage500": "#2664AC",
  "PropertiesBeauRivage900": "#173C67",
  "PropertiesBorgata25": "#ECE9F0",
  "PropertiesBorgata500": "#3F2767",
  "PropertiesBorgata900": "#26173E",
  "PropertiesEmpireCity25": "#E5E5E5",
  "PropertiesEmpireCity500": "#57555A",
  "PropertiesEmpireCity900": "#000000",
  "PropertiesMgmGrandDetroit25": "#F3F1ED",
  "PropertiesMgmGrandDetroit500": "#84724D",
  "PropertiesMgmGrandDetroit900": "#4F442E",
  "PropertiesMgmNationalHarbor25": "#E6E9EB",
  "PropertiesMgmNationalHarbor500": "#39505F",
  "PropertiesMgmNationalHarbor900": "#082437",
  "PropertiesMgmNorthfieldPark25": "#E7EEF1",
  "PropertiesMgmNorthfieldPark500": "#145475",
  "PropertiesMgmNorthfieldPark900": "#0C3246",
  "PropertiesMgmSpringfield25": "#ECF0F2",
  "PropertiesMgmSpringfield500": "#3F6C7D",
  "PropertiesMgmSpringfield900": "#26414B",
  "PropertiesW25": "#f3f3f3",
  "PropertiesW500": "#4c4c4c",
  "PropertiesW900": "#000000",
  "PropertiesSkySuites25": "#ECEDED",
  "PropertiesSkySuites500": "#7A99AC",
  "PropertiesSkySuites900": "#54585A",
  "PropertiesSkyLoft25": "#FFFFFF",
  "PropertiesSkyLoft500": "#8A8D8F",
  "PropertiesSkyLoft900": "#000000",
  "FontSizeActionsS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "FontSizeActionsM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "FgDefault": "#f6eddd",
  "FgMuted": "#a2a2a2",
  "FgSubtle": "#747474",
  "FgOnColor": "#ffffff",
  "FgGhost": "#00000000",
  "FgDefaultInverted": "#00012b",
  "FgContrast": "#a2a2a2",
  "FgHighContrast": "#ffffff",
  "FgPositive": "#66DC9C",
  "BgDefault": "#00012b",
  "BgSurface": "#0e0f59",
  "BgSubtle": "#1b1d88",
  "BgHighContrast": "#faf9f5",
  "InteractionPrimary": "#faf9f5",
  "InteractionDefault": "#f6eddd",
  "InteractionFocused": "#7a7cee",
  "InteractionMuted": "#1b1d88",
  "InteractionSubtle": "#0e0f59",
  "InteractionContrast": "#bcbdf6",
  "InteractionOnContrast": "#00012b",
  "InteractionAccessibleDefault": "#585be9",
  "InteractionPressed": "#f6eddd",
  "InteractionSecondary": "#f8f4ec",
  "DisabledDefault": "#747474",
  "DisabledMuted": "#a2a2a2",
  "DisabledSubtle": "#f5f5f5",
  "ErrorDefault": "#f70800",
  "ErrorSubtle": "#310200",
  "WarningDefault": "#FFAD33",
  "WarningSubtle": "#331F00",
  "SuccessDefault": "#00c55a",
  "SuccessSubtle": "#002712",
  "HighlightDefault": "#7a7cee",
  "HighlightSubtle": "#0e0f59",
  "ImmutableDefaultGradient": "linear-gradient(206deg, #373ae5 0%, #292cb7 52.08%)",
  "ImmutableDefaultSolid": "#373ae5",
  "BorderRadiusComponentXs": "4",
  "BorderRadiusComponentS": "6",
  "BorderRadiusComponentM": "8",
  "BorderRadiusComponentL": "10",
  "BorderRadiusComponentXl": "16",
  "BorderRadiusComponentCircular": "100",
  "BorderRadiusComponentNone": "0",
  "ShadowsFocused": "#373ae51a",
  "ShadowsElevation": "#b1966133",
  "TransparencySubtle": "#ffffff80",
  "TransparencyOverlay": "#00000066",
  "InformativeDefault": "#8b8b8b",
  "InformativeSubtle": "#171717",
  "TierStatusSapphire": "#2D5E75",
  "TierStatusPearl": "#EBE7E9",
  "TierStatusGold": "#BDA770",
  "TierStatusPlatinum": "#757275",
  "TierStatusNoir": "#000000",
  "SnackbarFillColor": "#ffffff",
  "SnackbarTextColor": "#00012b"
}